import { render, staticRenderFns } from "./dialogShareOrder.vue?vue&type=template&id=25b64943"
import script from "./dialogShareOrder.vue?vue&type=script&lang=js"
export * from "./dialogShareOrder.vue?vue&type=script&lang=js"
import style0 from "./dialogShareOrder.vue?vue&type=style&index=0&id=25b64943&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports